import Theme from '@dagensmat/carrot/Theme';
import styled from 'styled-components';

const Separator = styled.div`
  border-bottom: 1px solid ${Theme.Colours.lightGrey};
`;

export default Separator;
